<style lang="less">
.content {
  margin-top: 0;
}
.md-tab-bar {
  position: fixed;
  top: 1rem;
  z-index: 999;
  width: 100%;
  padding: 0;
  font-size: 0.26rem;
}
.md-tab-bar-item.is-active {
  color: #e32c1a;
}
.md-tab-bar-ink {
  background-color: #e32c1a;
}
.packItem {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
  margin-bottom: 0.2rem;
  border-radius: 0.1rem;
  width: 96%;
  margin-left: 2%;

  .packcompany {
    width: 100%;
    height: 0.8rem;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    justify-content: space-between;
    border: none;

    .packtitle {
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 0.2rem;
      color: #888888;

      img {
        width: 0.5rem;
        margin: 0 0.2rem;
      }
    }

    span {
      margin-right: 0.2rem;
    }
  }

  .pckdetail {
    width: 100%;
    padding-left: 0.2rem;
    font-size: 0.26rem;
    position: relative;

    .toptitle {
      width: 100%;
      display: flex;
      align-items: center;

      .tpleft {
        width: 50%;
        display: flex;
        align-items: center;
        font-size: 0.26rem;
        .iconbe {
          padding: 0.04rem 0.06rem;
          background-color: rgb(48, 125, 253);
          color: white;
          border-radius: 0.05rem;
        }

        .teicon {
          background-color: rgb(82, 204, 111);
        }
      }

      .alcenetr {
        justify-content: center;
        margin-top: 0.2rem;
      }

      .tpcenter {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: -5%;

        img {
          width: 100%;
        }
      }

      .tpcenright {
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.2rem;
      }
    }
  }

  .packopeartion {
    width: 98%;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .paymintci {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      color: #bb291d;
      margin-right: 8%;
    }
  }
}

.packageTyp {
  padding: 0.04rem 0.11rem;
  border-radius: 0.07rem;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(82, 204, 111, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.2rem;

  span {
    margin: 0 !important;
  }
}

.checkbtn {
  margin-left: 0.2rem;

  .md-check-icon {
    font-size: 0.8rem;
  }
}

.bottomView {
  position: fixed;
  width: 100%;
  height: 1rem;
  bottom: 1rem;
  margin-bottom: 0.2rem;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .checkall {
    height: 100%;
    display: flex;
    align-items: center;
    width: 20%;
    margin-left: 4%;

    span {
      margin-left: 0.1rem;
      font-size: 0.3rem;
    }
  }

  .chelist {
    width: 74%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cancle {
    font-size: 0.3rem;

    p {
      span {
        color: #e51c23;
        margin-right: 0.2rem;
      }
    }
  }
}
</style>
<template>
  <div ref="allpage">
    <search-modal
      ref="search"
      style="position: fixed; top: 0; width: 100%; z-index: 999"
      @toserch="toserch"
    />
    <md-tabs style="margin-top: 1rem" @change="changetable">
      <md-tab-pane name="0" :label="items[0].label" style="position: relative">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[0].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[0].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle" @click.stop="copy(item.code)">
                    訂單號：{{ item.code }}
                    <img
                      src="@/assets/image/copy.png"
                      alt=""
                      style="margin-left: 0.2rem"
                    />
                  </div>
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <div class="toptitle">
                    <div class="tpleft">
                      <div
                        class="iconbe teicon"
                        v-if="item.transportWay == '1'"
                      >
                        <span>特貨</span>
                      </div>
                      <div class="iconbe" v-else>
                        <span>普貨</span>
                      </div>
                      <span style="margin-left: 0.05rem">{{
                        item.transCode
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span>{{ item.weight }}KG</span>
                    </div>
                    <div class="tpcenright"></div>
                  </div>
                  <div class="toptitle">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.sendCountry
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <img src="@/assets/image/link.png" alt="" />
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.countryName
                      }}</span>
                    </div>
                  </div>
                  <div class="toptitle" style="margin-bottom: 0.26rem">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem">{{
                        item.warehouse
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span v-if="item.status == 1" style="color: #bb291d"
                        >待付款</span
                      >
                      <span v-if="item.status == 2">待收貨</span>
                      <span v-if="item.status == 3" style="color: #e51c23"
                        >已完成</span
                      >
                      <span v-if="item.status == 4" style="color: #666666"
                        >已取消</span
                      >
                      <span v-if="item.status == 5" style="color: #32c5ea"
                        >退款中</span
                      >
                      <span v-if="item.status == 6" style="color: #e51c23"
                        >支付待确认</span
                      >
                      <span v-if="item.status == 7" style="color: #e51c23"
                        >支付失败</span
                      >
                      <span v-if="item.status == 10" style="color: #888888"
                      >打包中</span>
                      <span v-if="item.status == 11" style="color: orangered"
                      >打包完成</span>
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem">{{ item.name }}</span>
                    </div>
                  </div>
                  <p
                    v-if="item.status == 2 || item.status == 3"
                    style="text-align: left"
                  >
                    付款時間：<span style="margin-left: -0.05rem">{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 10"
                    style="text-align: left"
                  >
                    提交時間：<span style="margin-left: -0.05rem">{{
                      item.createTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 11&&item.packageTime"
                    style="text-align: left"
                  >
                    打包時間：<span style="margin-left: -0.05rem">{{
                      item.packageTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p v-if="item.status == 7" style="text-align: left">
                    失败原因：<span style="margin-left: 0.05rem">{{
                      item.auditMemo
                    }}</span>
                  </p>
                </div>
                <div style="width: 100%; height: 0.3rem"></div>
                <div
                  v-if="item.trackInfo"
                  style="
                    background-color: rgb(242, 242, 242);
                    margin-bottom: 0.3rem;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      padding: 0.2rem;
                    "
                  >
                    <md-button type="primary" size="small" inline plain
                    >{{ item.trackInfo }}
                    </md-button>
                    <span style="font-size: 0.26rem; padding-right: 0.5rem">{{
                        item.trackDetail.eventtime
                      }}</span>
                  </div>
                  <p
                    style="
                      font-size: 0.3rem;
                      padding: 0 0.2rem 0.2rem 0.2rem;
                      text-align: left;
                      line-height: 0.5rem;
                    "
                  >
                    {{ item.trackDetail.eventscan }}
                  </p>
                </div>
                <div
                  class="packopeartion"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="cancelOther(item)"
                    round
                    v-if="item.status===10"
                    style="margin-right: 0.2rem"
                  >申请取消
                  </md-button>
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="godetail(item)"
                    round
                    v-if="item.status===11"
                    style="margin-right: 0.2rem"
                  >打包信息
                  </md-button>
                  <div class="paymintci"   v-if="item.status===1||item.status===7">
                    <span style="font-size: 0.3rem"
                    >需支付¥<md-amount
                      :value="item.totalPrice"
                      has-separator
                    ></md-amount
                    ></span>
                  </div>

                  <md-button
                    type="default"
                    size="small"
                    inline
                    v-if="item.status===1||item.status===6||item.status===7"
                    plain
                    @click="delet(item)"
                    round
                  >取消</md-button
                  >
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.2rem"
                    v-if="item.status===1||item.status===7"
                    @click="parpries(item)"
                    round
                  >去付款
                  </md-button>
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    v-if="item.status == 4||item.status == 3"
                    @click="deleteOrder(item)"
                    round
                    style="margin-right: 0.2rem"
                  >删除
                  </md-button>
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="cancel(item)"
                    round
                    v-if="item.status===2&&item.chargeMode===1"
                    style="margin-right: 0.2rem"
                  >申请取消
                  </md-button>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    v-if="item.status===2||item.status===3"
                    @click="look(item)"
                    round
                    style="margin-right: 0.2rem"
                    >查看物流
                  </md-button>
                </div>

              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane name="1" :label="items[1].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[1].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[1].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle" @click.stop="copy(item.code)">
                    訂單號：{{ item.code }}
                    <img
                      src="@/assets/image/copy.png"
                      alt=""
                      style="margin-left: 0.2rem"
                    />
                  </div>
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <div class="toptitle">
                    <div class="tpleft">
                      <div
                        class="iconbe teicon"
                        v-if="item.transportWay == '1'"
                      >
                        <span>特貨</span>
                      </div>
                      <div class="iconbe" v-else>
                        <span>普貨</span>
                      </div>
                      <span style="margin-left: 0.05rem">{{
                        item.transCode
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span>{{ item.weight }}KG</span>
                    </div>
                    <div class="tpcenright"></div>
                  </div>
                  <div class="toptitle">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.sendCountry
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <img src="@/assets/image/link.png" alt="" />
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.countryName
                      }}</span>
                    </div>
                  </div>
                  <div class="toptitle" style="margin-bottom: 0.26rem">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem">{{
                        item.warehouse
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span v-if="item.status == 1" style="color: #bb291d"
                        >待付款</span
                      >
                      <span v-if="item.status == 2">待收貨</span>
                      <span v-if="item.status == 3" style="color: #e51c23"
                        >已完成</span
                      >
                      <span v-if="item.status == 4" style="color: #666666"
                        >已取消</span
                      >
                      <span v-if="item.status == 5" style="color: #32c5ea"
                        >退款中</span
                      ><span v-if="item.status == 6" style="color: #e51c23"
                        >支付待确认</span
                      >
                      <span v-if="item.status == 7" style="color: #e51c23"
                        >支付失败</span
                      >
                      <span v-if="item.status == 10" style="color: #888888"
                      >打包中</span>
                      <span v-if="item.status == 11" style="color: orangered"
                      >打包完成</span>
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem">{{ item.name }}</span>
                    </div>
                  </div>
                  <p
                    v-if="item.status == 10"
                    style="text-align: left"
                  >
                    提交時間：<span style="margin-left: -0.05rem">{{
                      item.createTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 11&&item.packageTime"
                    style="text-align: left"
                  >
                    打包時間：<span style="margin-left: -0.05rem">{{
                      item.packageTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 2 || item.status == 3"
                    style="text-align: left"
                  >
                    付款時間：<span style="margin-left: -0.05rem">{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p v-if="item.status == 7" style="text-align: left">
                    失败原因：<span style="margin-left: 0.05rem">{{
                      item.auditMemo
                    }}</span>
                  </p>
                </div>
                <div style="width: 100%; height: 0.3rem"></div>
                <div
                  class="packopeartion"
                  v-if="item.status == 6"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status === 10"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="cancelOther(item)"
                    round
                  >申请取消</md-button
                  >
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 11"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="godetail(item)"
                    round
                  >打包信息</md-button
                  >
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 1 || item.status == 7"
                  style="margin-top: -0.3rem"
                >
                  <div class="paymintci">
                    <span style="font-size: 0.3rem"
                      >需支付¥<md-amount
                        :value="item.totalPrice"
                        has-separator
                      ></md-amount
                    ></span>
                  </div>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.2rem"
                    @click="parpries(item)"
                    round
                    >去付款
                  </md-button>
                </div>
                <div
                  v-if="item.trackInfo"
                  style="
                    background-color: rgb(242, 242, 242);
                    margin-bottom: 0.3rem;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      padding: 0.2rem;
                    "
                  >
                    <md-button type="primary" size="small" inline plain
                      >{{ item.trackInfo }}
                    </md-button>
                    <span style="font-size: 0.26rem; padding-right: 0.5rem">{{
                      item.trackDetail.eventtime
                    }}</span>
                  </div>
                  <p
                    style="
                      font-size: 0.3rem;
                      padding: 0 0.2rem 0.2rem 0.2rem;
                      text-align: left;
                      line-height: 0.5rem;
                    "
                  >
                    {{ item.trackDetail.eventscan }}
                  </p>
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 2 || item.status == 3"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="look(item)"
                    round
                    v-if="item.status===2||item.status===3"
                    style="margin-right: 0.2rem"
                    >查看物流
                  </md-button>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane name="2" :label="items[2].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[2].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[2].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle" @click.stop="copy(item.code)">
                    訂單號：{{ item.code }}
                    <img
                      src="@/assets/image/copy.png"
                      alt=""
                      style="margin-left: 0.2rem"
                    />
                  </div>
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <div class="toptitle">
                    <div class="tpleft">
                      <div
                        class="iconbe teicon"
                        v-if="item.transportWay == '1'"
                      >
                        <span>特貨</span>
                      </div>
                      <div class="iconbe" v-else>
                        <span>普貨</span>
                      </div>
                      <span style="margin-left: 0.05rem">{{
                        item.transCode
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span>{{ item.weight }}KG</span>
                    </div>
                    <div class="tpcenright"></div>
                  </div>
                  <div class="toptitle">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.sendCountry
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <img src="@/assets/image/link.png" alt="" />
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.countryName
                      }}</span>
                    </div>
                  </div>
                  <div class="toptitle" style="margin-bottom: 0.26rem">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem">{{
                        item.warehouse
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span v-if="item.status == 1" style="color: #bb291d"
                        >待付款</span
                      >
                      <span v-if="item.status == 2">待收貨</span>
                      <span v-if="item.status == 3" style="color: #e51c23"
                        >已完成</span
                      >
                      <span v-if="item.status == 4" style="color: #666666"
                        >已取消</span
                      >
                      <span v-if="item.status == 5" style="color: #32c5ea"
                        >退款中</span
                      ><span v-if="item.status == 6" style="color: #e51c23"
                        >支付待确认</span
                      >
                      <span v-if="item.status == 7" style="color: #e51c23"
                        >支付失败</span
                      >
                      <span v-if="item.status == 10" style="color: #888888"
                      >打包中</span>
                      <span v-if="item.status == 11" style="color: orangered"
                      >打包完成</span>
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem">{{ item.name }}</span>
                    </div>
                  </div>
                  <p
                    v-if="item.status == 10"
                    style="text-align: left"
                  >
                    提交時間：<span style="margin-left: -0.05rem">{{
                      item.createTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 11&&item.packageTime"
                    style="text-align: left"
                  >
                    打包時間：<span style="margin-left: -0.05rem">{{
                      item.packageTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 2 || item.status == 3"
                    style="text-align: left"
                  >
                    付款時間：<span style="margin-left: -0.05rem">{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p v-if="item.status == 7" style="text-align: left">
                    失败原因<span style="margin-left: -0.05rem">{{
                      item.auditMemo
                    }}</span>
                  </p>
                </div>
                <div style="width: 100%; height: 0.3rem"></div>
                <div
                  class="packopeartion"
                  v-if="item.status == 6"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 1 || item.status == 7"
                  style="margin-top: -0.3rem"
                >
                  <div class="paymintci">
                    <span style="font-size: 0.3rem"
                      >需支付¥<md-amount
                        :value="item.totalPrice"
                        has-separator
                      ></md-amount
                    ></span>
                  </div>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.2rem"
                    @click="parpries(item)"
                    round
                    >去付款
                  </md-button>
                </div>
                <div
                  v-if="item.trackInfo"
                  style="
                    background-color: rgb(242, 242, 242);
                    margin-bottom: 0.3rem;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      padding: 0.2rem;
                    "
                  >
                    <md-button type="primary" size="small" inline plain
                      >{{ item.trackInfo }}
                    </md-button>
                    <span style="font-size: 0.26rem; padding-right: 0.5rem">{{
                      item.trackDetail.eventtime
                    }}</span>
                  </div>
                  <p
                    style="
                      font-size: 0.3rem;
                      padding: 0 0.2rem 0.2rem 0.2rem;
                      text-align: left;
                      line-height: 0.5rem;
                    "
                  >
                    {{ item.trackDetail.eventscan }}
                  </p>
                </div>
                <div
                  class="packopeartion"

                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="cancel(item)"
                    round
                    v-if="(item.status == 2 || item.status == 3)&&item.chargeMode===1"
                    style="margin-right: 0.2rem"
                    >申请取消
                  </md-button>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="look(item)"
                    round
                    v-if="item.status===2||item.status===3"
                    style="margin-right: 0.2rem"
                    >查看物流
                  </md-button>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 3rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane name="3" :label="items[3].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[3].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[3].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle" @click.stop="copy(item.code)">
                    訂單號：{{ item.code }}
                    <img
                      src="@/assets/image/copy.png"
                      alt=""
                      style="margin-left: 0.2rem"
                    />
                  </div>
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <div class="toptitle">
                    <div class="tpleft">
                      <div
                        class="iconbe teicon"
                        v-if="item.transportWay == '1'"
                      >
                        <span>特貨</span>
                      </div>
                      <div class="iconbe" v-else>
                        <span>普貨</span>
                      </div>
                      <span style="margin-left: 0.1rem">{{
                        item.transCode
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span>{{ item.weight }}KG</span>
                    </div>
                  </div>
                  <div class="toptitle">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.sendCountry
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <img src="@/assets/image/link.png" alt="" />
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.countryName
                      }}</span>
                    </div>
                  </div>
                  <div class="toptitle" style="margin-bottom: 0.26rem">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem">{{
                        item.warehouse
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span v-if="item.status == 1" style="color: #bb291d"
                        >待付款</span
                      >
                      <span v-if="item.status == 2">待收貨</span>
                      <span v-if="item.status == 3" style="color: #e51c23"
                        >已完成</span
                      >
                      <span v-if="item.status == 4" style="color: #666666"
                        >已取消</span
                      >
                      <span v-if="item.status == 5" style="color: #32c5ea"
                        >退款中</span
                      >
                      <span v-if="item.status == 6" style="color: #e51c23"
                        >支付待确认</span
                      >
                      <span v-if="item.status == 7" style="color: #bb291d"
                        >支付失败</span
                      >
                      <span v-if="item.status == 10" style="color: #888888"
                      >打包中</span>
                      <span v-if="item.status == 11" style="color: orangered"
                      >打包完成</span>
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem">{{ item.name }}</span>
                    </div>
                  </div>
                  <p
                    v-if="item.status == 10"
                    style="text-align: left"
                  >
                    提交時間：<span style="margin-left: -0.05rem">{{
                      item.createTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 11&&item.packageTime"
                    style="text-align: left"
                  >
                    打包時間：<span style="margin-left: -0.05rem">{{
                      item.packageTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p
                    v-if="item.status == 2 || item.status == 3"
                    style="text-align: left"
                  >
                    付款時間：<span style="margin-left: -0.05rem">{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p v-if="item.status == 7" style="text-align: left">
                    失败原因<span style="margin-left: -0.05rem">{{
                      item.auditMemo
                    }}</span>
                  </p>
                </div>
                <div style="width: 100%; height: 0.2rem"></div>
                <div
                  class="packopeartion"
                  v-if="item.status == 6"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 1 || item.status == 7"
                  style="margin-top: -0.3rem"
                >
                  <div class="paymintci">
                    <span style="font-size: 0.3rem"
                      >需支付¥<md-amount
                        :value="item.totalPrice"
                        has-separator
                      ></md-amount
                    ></span>
                  </div>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.2rem"
                    @click="parpries(item)"
                    round
                    >去付款
                  </md-button>
                </div>
                <div
                  v-if="item.trackInfo"
                  style="
                    background-color: rgb(242, 242, 242);
                    margin-bottom: 0.3rem;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      padding: 0.2rem;
                    "
                  >
                    <md-button type="primary" size="small" inline plain
                      >{{ item.trackInfo }}
                    </md-button>
                    <span style="font-size: 0.26rem; padding-right: 0.5rem">{{
                      item.trackDetail.eventtime
                    }}</span>
                  </div>
                  <p
                    style="
                      font-size: 0.3rem;
                      padding: 0 0.2rem 0.2rem 0.2rem;
                      text-align: left;
                      line-height: 0.5rem;
                    "
                  >
                    {{ item.trackDetail.eventscan }}
                  </p>
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 2 || item.status == 3"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="warning"
                    size="small"
                    v-if="item.status == 4||item.status == 3"
                    inline
                    plain
                    @click="deleteOrder(item)"
                    round
                    style="margin-right: 0.2rem"
                    >删除
                  </md-button>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="look(item)"
                    round
                    v-if="item.status===2||item.status===3"
                    style="margin-right: 0.2rem"
                    >查看物流
                  </md-button>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 3rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane name="4" :label="items[4].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[4].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[4].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle" @click.stop="copy(item.code)">
                    訂單號：{{ item.code }}
                    <img
                      src="@/assets/image/copy.png"
                      alt=""
                      style="margin-left: 0.2rem"
                    />
                  </div>
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <div class="toptitle">
                    <div class="tpleft">
                      <div
                        class="iconbe teicon"
                        v-if="item.transportWay == '1'"
                      >
                        <span>特貨</span>
                      </div>
                      <div class="iconbe" v-else>
                        <span>普貨</span>
                      </div>
                      <span style="margin-left: 0.05rem">{{
                        item.transCode
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span>{{ item.weight }}KG</span>
                    </div>
                    <div class="tpcenright"></div>
                  </div>
                  <div class="toptitle">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.sendCountry
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <img src="@/assets/image/link.png" alt="" />
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem; font-weight: bold">{{
                        item.countryName
                      }}</span>
                    </div>
                  </div>
                  <div class="toptitle" style="margin-bottom: 0.26rem">
                    <div class="tpleft alcenetr">
                      <span style="font-size: 0.3rem">{{
                        item.warehouse
                      }}</span>
                    </div>
                    <div class="tpcenter">
                      <span v-if="item.status == 1" style="color: #bb291d"
                        >待付款</span
                      >
                      <span v-if="item.status == 2">待收貨</span>
                      <span v-if="item.status == 3" style="color: #e51c23"
                        >已完成</span
                      >
                      <span v-if="item.status == 4" style="color: #666666"
                        >已取消</span
                      >
                      <span v-if="item.status == 5" style="color: #32c5ea"
                        >退款中</span
                      >
                      <span v-if="item.status == 6" style="color: #e51c23"
                        >支付待确认</span
                      >
                      <span v-if="item.status == 7" style="color: #bb291d"
                        >支付失败</span
                      >
                      <span v-if="item.status == 10" style="color: #888888"
                      >打包中</span>
                      <span v-if="item.status == 11" style="color: orangered"
                      >打包完成</span>
                    </div>
                    <div class="tpcenright">
                      <span style="font-size: 0.3rem">{{ item.name }}</span>
                    </div>
                  </div>
                  <p
                    v-if="item.status == 2 || item.status == 3"
                    style="text-align: left"
                  >
                    付款時間：<span style="margin-left: -0.05rem">{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p v-if="item.status == 7" style="text-align: left">
                    失败原因<span style="margin-left: -0.05rem">{{
                      item.auditMemo
                    }}</span>
                  </p>
                </div>
                <div style="width: 100%; height: 0.2rem"></div>
                <div
                  class="packopeartion"
                  v-if="item.status == 6"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 1 || item.status == 7"
                  style="margin-top: -0.3rem"
                >
                  <div class="paymintci">
                    <span style="font-size: 0.3rem"
                      >需支付¥<md-amount
                        :value="item.totalPrice"
                        has-separator
                      ></md-amount
                    ></span>
                  </div>
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    @click="delet(item)"
                    round
                    >取消</md-button
                  >
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.2rem"
                    @click="parpries(item)"
                    round
                    >去付款
                  </md-button>
                </div>
                <div
                  v-if="item.trackInfo"
                  style="
                    background-color: rgb(242, 242, 242);
                    margin-bottom: 0.3rem;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      padding: 0.2rem;
                    "
                  >
                    <md-button type="primary" size="small" inline plain
                      >{{ item.trackInfo }}
                    </md-button>
                    <span style="font-size: 0.26rem; padding-right: 0.5rem">{{
                      item.trackDetail.eventtime
                    }}</span>
                  </div>
                  <p
                    style="
                      font-size: 0.3rem;
                      padding: 0 0.2rem 0.2rem 0.2rem;
                      text-align: left;
                      line-height: 0.5rem;
                    "
                  >
                    {{ item.trackDetail.eventscan }}
                  </p>
                </div>
                <div
                  class="packopeartion"
                  v-if="item.status == 4||item.status == 3"
                  style="margin-top: -0.3rem"
                >
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    @click="deleteOrder(item)"
                    round
                    style="margin-right: 0.2rem"
                    >删除
                  </md-button>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
    </md-tabs>
    <div style="width: 100%; height: 1.2rem"></div>
  </div>
</template>
<script>
import {
  Button,
  Icon,
  Tabs,
  TabPane,
  Toast,
  Check,
  CheckGroup,
  Amount,
  Dialog
} from "mand-mobile";
import NothModal from "../Modal/NothModal";
import SearchModal from "../package/Modal/SearchModal";
import DropDownRefresh from "../../components/refresh";
import PullUpReload from "../../components/pullDown";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Amount.name]: Amount,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Check.name]: Check,
    [CheckGroup.name]: CheckGroup,
    SearchModal,
    // eslint-disable-next-line vue/no-unused-components
    "v-refresh": DropDownRefresh,
    // eslint-disable-next-line vue/no-unused-components
    "v-reload": PullUpReload,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  name: "Package",
  data() {
    return {
      infiniteLoadData: {
        initialShowNum: 5, // 初始显示多少条
        everyLoadingNum: 5, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },
      isFinished: false,
      current: "0",
      pagenum: 1,
      list: [
        { packlist: [] },
        { packlist: [] },
        { packlist: [] },
        { packlist: [] },
        { packlist: [] }
      ],
      items: [
        { name: 0, label: "全部" },
        { name: 1, label: "待付款" },
        { name: 2, label: "待收貨" },
        { name: 3, label: "已完成" },
        {
          name: 4,
          label: "已取消"
        }
      ]
    };
  },
  activated() {
    localStorage.removeItem("serorder");
    if (localStorage.getItem("fleshorder")) {
      this.pagenum = 1;
      this.parcelsimpleStatus(null);
    }
  },

  methods: {
    getlist(opear) {
      const par = {
        keyword: "",
        pageNum: this.pagenum,
        pageSize: 20,
        sort: false,
        status: this.current
      };
      this.http
        .APIASK(this.ports.orderlist, "get", par)
        .then(res => {
          if (opear) {
            if (res.list.length > 0) {
              this.list[this.current].packlist = this.list[
                this.current
              ].packlist.concat(res.list);
              this.infiniteLoadData.pullUpList = this.list[
                this.current
              ].packlist;
              if (res.list.length < 5) {
                this.infiniteLoadData.pullUpState = 3;
              } else {
                this.infiniteLoadData.pullUpState = 1;
              }
            } else {
              this.infiniteLoadData.pullUpState = 3;
            }
          } else {
            if (res.list.length < 5) {
              this.infiniteLoadData.pullUpState = 3;
            } else {
              this.infiniteLoadData.pullUpState = 1;
            }
            this.list[this.current].packlist = res.list;
            this.infiniteLoadData.pullUpList = this.list[this.current].packlist;
          }
          this.list[this.current].packlist.length < 3
            ? (this.infiniteLoadData.pullUpState = 0)
            : null;
          Toast.hide();
          console.log(this.favorites);
        })
        .catch(err => {
          Toast.hide();
        });
    },
    parcelsimpleStatus(opear) {
      localStorage.removeItem("fleshorder");
      this.http
        .APIASK(this.ports.simpleStatus, "get")
        .then(res => {
          res["0"] > 0
            ? (this.items[0].label = "全部" + res["0"])
            : (this.items[0].label = "全部"),
            res["1"] > 0
              ? (this.items[1].label = "待付款" + res["1"])
              : (this.items[1].label = "待付款"),
            res["2"] > 0
              ? (this.items[2].label = "待收貨" + res["2"])
              : (this.items[2].label = "待收貨"),
            res["3"] > 0
              ? (this.items[3].label = "已完成" + res["3"])
              : (this.items[3].label = "已完成"),
            res["4"] > 0
              ? (this.items[4].label = "已取消" + res["4"])
              : (this.items[4].label = "已取消"),
            this.getlist(opear);
        })
        .catch(err => {
          Toast.hide();
        });
    },
    toserch() {
      this.$router.push({ name: "OrderSearch" });
    },
    copy(name) {
      const url = name;
      const oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
      Toast.succeed("複製成功");
    },
    look(item) {
      this.$router.push({
        name: "OrderLogin",
        query: {
          des: JSON.stringify(item)
        }
      });
    },
    godetail(item) {
      this.$router.push({ name: "OrderDetail", query: { id: item.id } });
    },
    parpries(item) {
      Dialog.confirm({
        content: "是否去支付？",
        confirmText: "確定",
        onConfirm: () => {
          this.$router.push({
            name: "Pay",
            query: {
              id: item.id,
              price: item.totalPrice.toFixed(2)
            }
          });
        }
      });
    },
    changetable(item, index) {
      this.current = item.name;
      this.pagenum = 1;
      this.infiniteLoadData.pullUpList = [];
      this.infiniteLoadData.pullUpState = 4;
      this.parcelsimpleStatus(null);
    },
    canclePack(item){
      Dialog.confirm({
        title: "提示",
        content:'确定要取消支付吗',
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id
          };
          this.http
            .APIASK(this.ports.cancelAfootOverNoPay, "get", par)
            .then(res => {
              localStorage.setItem("fleshpack", 1);
              this.parcelsimpleStatus(null);
              Toast.succeed("取消成功");
            })
            .catch(err => {});
        }
      });
    },
    delet(item) {
      console.log('item',item)
      if(item.chargeMode===2){
        this.canclePack(item)
        return
      }
      const itemvale = JSON.parse(localStorage.getItem("countryList")).filter(
        val => {
          return val.id == item.countryId;
        }
      );
      console.log(itemvale);
      Dialog.confirm({
        title: "確認要取消這個訂單嗎？",
        content:
          itemvale.length > 0 && itemvale[0].code == "TW"
            ? "商超支付非即时入帐，存在2~3天延迟，如您已实际支付订单请不要取消订单，以免造成不便"
            : "訂單取消後，您可以在已入庫包裹中重新合單",
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id
          };
          this.http
            .APIASK(this.ports.ordercancel, "get", par)
            .then(res => {
              localStorage.setItem("fleshpack", 1);
              this.parcelsimpleStatus(null);
              Toast.succeed("取消成功");
            })
            .catch(err => {});
        }
      });
    },
    deleteOrder(item) {
      Dialog.confirm({
        title: "確認要删除這個訂單嗎？",
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id
          };
          this.http
            .APIASK(this.ports.delOrder, "post", par)
            .then(res => {
              localStorage.setItem("fleshpack", 1);
              this.parcelsimpleStatus(null);
              Toast.succeed("删除成功");
            })
            .catch(err => {});
        }
      });
    },
    cancel(item) {
      Dialog.confirm({
        title: "確認要取消這個訂單嗎？",
        content:
          "如您的貨物倉庫還未開始操作，訂單會立即取消。 如取消失敗，請聯系客服截停倉庫操作，取消與否以客服資訊為准",
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id
          };
          this.http
            .APIASK(this.ports.cancelorder, "get", par)
            .then(res => {
              localStorage.setItem("fleshpack", 1);
              this.parcelsimpleStatus(null);
              Toast.succeed("取消成功");
            })
            .catch(err => {});
        }
      });
    },
    cancelOther(item){
      Dialog.confirm({
        title: "确定要取消这个订单吗？",
        content:
          "如您的货物仓库还未开始操作，订单会立即取消。如取消失败，请联系客服截停仓库操作，取消与否以客服信息为准。",
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id
          };
          this.http
            .APIASK(this.ports.cancelAfoot, "get", par)
            .then(res => {
              localStorage.setItem("fleshpack", 1);
              this.parcelsimpleStatus(null);
              Toast.succeed("取消成功");
            })
            .catch(err => {});
        }
      });
    },
    onRefreshone(done) {
      setTimeout(() => {
        this.infiniteLoadData.pullUpList = [];
        this.pagenum = 1;
        this.parcelsimpleStatus(null);
        done();
      }, 500);
    },

    getStartPullUpState() {
      if (this.infiniteLoadData.pullUpList.length) {
        if (
          this.list[this.current].packlist.length <=
          this.infiniteLoadData.initialShowNum
        ) {
          // 修改子组件的pullUpState状态
          this.infiniteLoadData.pullUpState = 3;
        } else {
          this.infiniteLoadData.pullUpState = 1;
        }
      } else {
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    infinite(done) {
      console.log(this.infiniteLoadData.pullUpState);
      if (this.infiniteLoadData.pullUpState === 1) {
        setTimeout(() => {
          this.pagenum++;
          this.getlist("load");
          done();
        }, 500);
      } else {
        done();
        this.infiniteLoadData.pullUpState = 0;
      }
    }
  },
  mounted() {
    this.$refs.search.message = "訂單號、 國內快遞單號";
    Toast.loading("加載中...");
    this.parcelsimpleStatus(null);
  }
};
</script>
